import React from 'react';
import '../styles/About.css';
import '../styles/ScrollAnimation.css';
import ScrollAnimation from '../utils/ScrollAnimation';

const EXPERIENCES = [
  {
    title: 'Senior Full-Stack Developer',
    company: 'Freelance / Contract',
    meta: 'Remote • 2020 – Present',
  },
  {
    title: 'Full-Stack Developer',
    company: 'Product & Agency Projects',
    meta: 'Remote • 2019 – 2020',
  },
];

const DESIGN_SKILLS = [
  'API Design',
  'System Architecture',
  'Full-Stack Apps',
  'AI Integrations',
  'Performance Tuning',
  'DevOps & CI/CD',
];

const TOOLS = [
  'Django / FastAPI',
  'Ruby on Rails',
  'React / Next.js',
  'PostgreSQL / Redis',
  'AWS / Docker',
  'Stripe / Shopify',
];

const EDUCATION = [
  {
    title: 'Bachelor of Software Engineering',
    meta: 'University • Focused on distributed systems & web engineering',
  },
  {
    title: 'Production Engineering Practice',
    meta: 'Shipping multi-tenant SaaS, marketplaces, and commerce tooling',
  },
];

const STATS = [
  { value: '20+', label: 'Projects' },
  { value: '10K+', label: 'Users Reached' },
  { value: '5+', label: 'Years' },
  { value: '24H', label: 'Avg Response' },
];

const About = () => {
  return (
    <section id="about" className="about section">
      <div className="container">
        <ScrollAnimation className="fade-up">
          <div className="about-header">
            <h2 className="section-title">About Me</h2>
            <div className="divider-glow" />
            <p className="about-bio">
              ⤷ Senior Full-Stack Developer | Django • Rails • React specialist | Shipping
              production systems for construction, cybersecurity, hiring, commerce, and AI
              platforms
            </p>
          </div>
        </ScrollAnimation>

        <div className="about-layout">
          <ScrollAnimation className="fade-up">
            <div className="about-panel">
              <h3 className="about-panel-title">Experience</h3>
              <p className="about-panel-lead">
                I collaborate with startups and product teams to take messy prototypes to
                reliable production — APIs, data models, background jobs, and the interfaces
                on top.
              </p>
              <ul className="about-experience">
                {EXPERIENCES.map((exp) => (
                  <li key={exp.title} className="about-experience-item">
                    <div className="about-experience-dot" />
                    <div>
                      <h4>{exp.title}</h4>
                      <p>{exp.company}</p>
                      <span>{exp.meta}</span>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </ScrollAnimation>

          <ScrollAnimation className="fade-up" delay={80}>
            <div className="about-panel about-panel--skills">
              <h3 className="about-panel-title">Skills</h3>
              <div className="about-skills-grid">
                <div>
                  <p className="about-skills-label">Expertise</p>
                  <ul>
                    {DESIGN_SKILLS.map((skill) => (
                      <li key={skill}>{skill}</li>
                    ))}
                  </ul>
                </div>
                <div>
                  <p className="about-skills-label">Tools</p>
                  <ul>
                    {TOOLS.map((tool) => (
                      <li key={tool}>{tool}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </ScrollAnimation>
        </div>

        <ScrollAnimation className="fade-up">
          <div className="about-education">
            <h3 className="section-title about-edu-title">Education & Focus</h3>
            <div className="divider-glow" />
            <div className="about-edu-grid">
              {EDUCATION.map((item) => (
                <article key={item.title} className="about-edu-card">
                  <h4>{item.title}</h4>
                  <p>{item.meta}</p>
                </article>
              ))}
            </div>
            <div className="about-edu-actions">
              <a
                href="https://www.linkedin.com/in/muqeet-ahmad-ma/"
                className="btn btn--primary"
                target="_blank"
                rel="noopener noreferrer"
              >
                Explore Profile
              </a>
              <a
                href="https://github.com/MuqeetJanjua"
                className="btn btn--ghost"
                target="_blank"
                rel="noopener noreferrer"
              >
                Visit GitHub
              </a>
            </div>
          </div>
        </ScrollAnimation>

        <ScrollAnimation className="fade-up">
          <div className="about-stats">
            {STATS.map((stat) => (
              <div key={stat.label} className="about-stat">
                <span className="about-stat-value">{stat.value}</span>
                <span className="about-stat-label">{stat.label}</span>
              </div>
            ))}
          </div>
        </ScrollAnimation>
      </div>
    </section>
  );
};

export default About;
